import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment from 'moment';
import { getAction } from '@/api/manage';
import lineEchart from '@/views/om/quality/modules/lineEchart';
import * as echarts from 'echarts';
export default {
  name: 'AssetEquipmentRepairList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    lineEchart: lineEchart
  },
  data: function data() {
    return {
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      activeKey: '1',
      // 表头
      columns: [{
        title: '日期',
        dataIndex: 'dateTime',
        key: 'dateTime',
        width: 200,
        align: 'center'
      }],
      zeroDatas: [],
      spanDatas: [],
      Pinformation: [],
      //因子列表
      //因子往期记录
      FactorPreviouslist: [],
      factorStr: '',
      pagePath: '/om/day/quality/zero',
      // 零点数据
      xAxisData: [],
      actionData: [],
      yAxisData: [],
      colorData: [],
      // 跨度数据
      spanData: [],
      yAxisSpanData: [],
      xAxisSpanData: [],
      colorSpanData: [],
      PinformationChart: [],
      // errorStandard: '0',
      spanErrorStandard: '0'
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
        this.delayLoadData();
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }
    }
  },
  created: function created() {
    this.queryParam.status = 1;
    this.queryParam.stime = moment().subtract(1, 'weeks').format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss');
  },
  computed: {},
  methods: {
    switchTab: function switchTab(e) {
      var _this = this;

      console.log('Listvalue', e);
      this.activeKey = e;

      if (this.activeKey == 3) {
        this.pagePath = '/om/day/quality/span';
        this.getspanData();
      } else if (this.activeKey == 1) {
        this.pagePath = '/om/day/quality/zero';
        this.loadData();
      } else if (this.activeKey == 2) {
        this.pagePath = '/om/day/quality/zero';
        this.$nextTick(function () {
          _this.getActionChart();
        });
      } else if (this.activeKey == 4) {
        this.pagePath = '/om/day/quality/span';
        this.$nextTick(function () {
          _this.getSpanChart();
        });
      }
    },
    moment: moment,
    onDateChange: function onDateChange(value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
      this.loadData();
    },
    //加载检测因子
    loadData: function loadData() {
      var _this2 = this;

      var h = this.$createElement;
      this.Pinformation = [];
      this.columns = [{
        title: '日期',
        dataIndex: 'dateTime',
        key: 'dateTime',
        width: 200,
        align: 'center'
      }];
      var params = {
        siteId: this.queryParam.scopeId,
        stime: this.queryParam.stime,
        etime: this.queryParam.etime,
        factorStr: this.queryParam.factorStr
      }; // 零点数据

      getAction('/om/day/quality/zero', params).then(function (res) {
        console.log('/om/day/quality/zero', res);

        if (res.success) {
          _this2.zeroDatas = [];

          if (res.result.length) {
            var temp = res.result[0].timeFactorModels;
            var temps = res.result[0].factorModels;
            _this2.Pinformation = temp;
            _this2.zeroDatas = res.result;
            console.log('this.Pinformation', _this2.Pinformation);
            temps.forEach(function (item) {
              console.log('item.title', item);

              _this2.columns.push({
                title: item.title + '(' + item.unitName + ')',
                children: [{
                  title: '测试结果',
                  dataIndex: 'checkValue',
                  align: 'center',
                  key: 'checkValue',
                  width: 100,
                  customRender: function customRender(text, temptext, index) {
                    console.log('text, temptext, index', text, temptext, index);

                    if (temptext.qcData[item.code] == undefined) {
                      return '';
                    } else {
                      return h("span", {
                        "class": "redText",
                        "attrs": {
                          "title": '原始数据： ' + temptext.qcData[item.code].checkValue
                        }
                      }, [temptext.qcData[item.code].checkValue.toFixed(2) + ' ' + temptext.qcData[item.code].flag]);
                    }
                  }
                }, {
                  title: '跨度核查',
                  children: [{
                    title: '标准样浓度',
                    dataIndex: 'standardValue',
                    key: 'standardValue',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].standardValue
                          }
                        }, [temptext.qcData[item.code].standardValue]);
                      }
                    }
                  }, {
                    title: '相对误差',
                    dataIndex: 'absoluteError',
                    key: 'absoluteError',
                    width: 100,
                    align: 'center',
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].absoluteError
                          }
                        }, [temptext.qcData[item.code].absoluteError.toFixed(2)]);
                      }
                    }
                  }, {
                    title: '合理情况',
                    dataIndex: 'zeroValid',
                    key: 'zeroValid',
                    width: 100,
                    align: 'center',
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "style": temptext.qcData[item.code].zeroValid == '不合格' ? 'color:red' : ''
                        }, [temptext.qcData[item.code].zeroValid]);
                      }
                    }
                  }]
                }, {
                  title: '24小时跨度漂移',
                  children: [{
                    title: '前一次测试结果',
                    dataIndex: 'preCheckValue',
                    key: 'preCheckValue',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].preCheckValue
                          }
                        }, [temptext.qcData[item.code].preCheckValue.toFixed(2) + ' ' + temptext.qcData[item.code].preFlag]);
                      }
                    }
                  }, {
                    title: '跨度值',
                    dataIndex: 'spanValue',
                    key: 'spanValue',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].spanValue
                          }
                        }, [temptext.qcData[item.code].spanValue.toFixed(2)]);
                      }
                    }
                  }, {
                    title: '相对误差',
                    dataIndex: 'zeroDriftRelativeError',
                    key: 'zeroDriftRelativeError',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", [temptext.qcData[item.code].zeroDriftRelativeError]);
                      }
                    }
                  }, {
                    title: '合格情况',
                    dataIndex: 'zeroDriftValid',
                    key: 'zeroDriftValid',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "style": temptext.qcData[item.code].zeroDriftValid == '不合格' ? 'color:red' : ''
                        }, [temptext.qcData[item.code].zeroDriftValid]);
                      }
                    }
                  }]
                }]
              });
            });
          }
        }
      });
    },
    //list站点列表code值
    handleChange: function handleChange(value) {
      this.queryParam.factorStr = '';

      for (var i = 0; i < value.length; i++) {
        var part = value[i];
        this.queryParam.factorStr = part + ',' + this.queryParam.factorStr;
      }
    },
    searchQuery: function searchQuery() {
      var _this3 = this;

      if (this.activeKey == 1) {
        this.loadData();
      } else if (this.activeKey == 3) {
        this.getspanData();
      } else if (this.activeKey == 2) {
        this.$nextTick(function () {
          _this3.getActionChart();
        });
      } else if (this.activeKey == 4) {
        this.$nextTick(function () {
          _this3.getSpanChart();
        });
      }
    },
    getspanData: function getspanData() {
      var _this4 = this;

      var h = this.$createElement;
      var param = {
        siteId: this.queryParam.scopeId,
        stime: this.queryParam.stime,
        etime: this.queryParam.etime,
        factorStr: this.queryParam.factorStr
      };
      this.columns = [{
        title: '日期',
        dataIndex: 'dateTime',
        key: 'dateTime',
        width: 200,
        align: 'center'
      }]; // 跨度数据

      getAction('/om/day/quality/span', param).then(function (res) {
        console.log('/om/day/quality/span', res);

        if (res.success) {
          _this4.spanDatas = [];

          if (res.result.length) {
            _this4.spanDatas = res.result;
            var tems = res.result[0].factorModels;
            console.log('/om/day/quality/span', _this4.temps);
            tems.forEach(function (item) {
              _this4.columns.push({
                title: item.title + '(' + item.unitName + ')',
                children: [{
                  title: '测试结果',
                  dataIndex: 'checkValue',
                  align: 'center',
                  key: 'checkValue',
                  width: 100,
                  customRender: function customRender(text, temptext, index) {
                    if (temptext.qcData[item.code] == undefined) {
                      return '';
                    } else {
                      return h("span", {
                        "class": "redText",
                        "attrs": {
                          "title": '原始数据： ' + temptext.qcData[item.code].forMatCheckValue
                        }
                      }, [temptext.qcData[item.code].forMatCheckValue]);
                    }
                  }
                }, {
                  title: '跨度核查',
                  children: [{
                    title: '标准样浓度',
                    dataIndex: 'standardValue',
                    key: 'standardValue',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].standardValue
                          }
                        }, [temptext.qcData[item.code].standardValue]);
                      }
                    }
                  }, {
                    title: '相对误差',
                    dataIndex: 'absoluteError',
                    key: 'absoluteError',
                    width: 100,
                    align: 'center',
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        if (temptext.qcData[item.code].spanRelativeError == null) {
                          return '';
                        } else {
                          return h("span", {
                            "class": "redText",
                            "attrs": {
                              "title": '原始数据： ' + temptext.qcData[item.code].spanRelativeError
                            }
                          }, [temptext.qcData[item.code].spanRelativeError]);
                        }
                      }
                    }
                  }, {
                    title: '合理情况',
                    dataIndex: 'spanValid',
                    key: 'spanValid',
                    width: 100,
                    align: 'center',
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "style": temptext.qcData[item.code].spanValid == '不合格' ? 'color:red' : ''
                        }, [temptext.qcData[item.code].spanValid]);
                      }
                    }
                  }]
                }, {
                  title: '24小时跨度漂移',
                  children: [{
                    title: '前一次测试结果',
                    dataIndex: 'preCheckValue',
                    key: 'preCheckValue',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].preCheckValue
                          }
                        }, [temptext.qcData[item.code].preCheckValue.toFixed(2)]);
                      }
                    }
                  }, {
                    title: '跨度值',
                    dataIndex: 'spanValue',
                    key: 'spanValue',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "class": "redText",
                          "attrs": {
                            "title": '原始数据： ' + temptext.qcData[item.code].spanValue
                          }
                        }, [temptext.qcData[item.code].spanValue.toFixed(2)]);
                      }
                    }
                  }, {
                    title: '相对误差',
                    dataIndex: 'spanDriftRelativeError',
                    key: 'spanDriftRelativeError',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", [temptext.qcData[item.code].spanDriftRelativeError]);
                      }
                    }
                  }, {
                    title: '合格情况',
                    dataIndex: 'spanDriftValid',
                    key: 'spanDriftValid',
                    align: 'center',
                    width: 100,
                    customRender: function customRender(text, temptext, index) {
                      if (temptext.qcData[item.code] == undefined) {
                        return '';
                      } else {
                        return h("span", {
                          "style": temptext.qcData[item.code].spanDriftValid == '不合格' ? 'color:red' : ''
                        }, [temptext.qcData[item.code].spanDriftValid]);
                      }
                    }
                  }]
                }]
              });
            });
          }
        }
      });
    },
    // 零点图表
    drawActionChart: function drawActionChart() {
      var _this5 = this;

      console.log('this.PinformationChart', this.PinformationChart);

      var echarts = require('echarts'); //先引入echarts


      var roseCharts = document.getElementsByClassName('zeroDataChart');

      for (var i = 0; i < this.PinformationChart.length; i++) {
        var myChart = echarts.init(roseCharts[i]);
        this.yAxisData = [];
        this.colorData = [];
        this.actionData.forEach(function (item) {
          if (item.qcData[_this5.PinformationChart[i].code]) {
            _this5.yAxisData.push(item.qcData[_this5.PinformationChart[i].code].zeroDriftRelativeError.replace('%', '') - 0);

            _this5.colorData.push(item.qcData[_this5.PinformationChart[i].code].zeroDriftValid);

            _this5.errorStandard = item.qcData[_this5.PinformationChart[i].code].errorStandard;
          } else {
            _this5.yAxisData.push('');

            _this5.colorData.push('');
          }
        });
        var option = {
          title: {
            text: '24小时零点漂移历史数据',
            subtext: this.PinformationChart[i].title,
            left: 'center'
          },
          toolbox: {
            show: true,
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              magicType: {
                show: true,
                type: ['line', 'bar']
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            textStyle: {
              // 文字提示样式
              color: '#fff',
              fontSize: '12'
            }
          },
          xAxis: {
            name: '时间',
            type: 'category',
            data: this.xAxisData
          },
          yAxis: {
            name: '相对误差(%)',
            type: 'value'
          },
          series: [{
            name: this.PinformationChart[i].title,
            data: this.yAxisData,
            type: 'line',
            symbol: 'triangle',
            symbolSize: 20,
            markLine: {
              data: [{
                yAxis: this.errorStandard - 0,
                name: 'max'
              }, {
                yAxis: 0 - this.errorStandard,
                name: 'min'
              }]
            },
            lineStyle: {
              color: 'green',
              width: 4,
              type: 'dashed'
            },
            itemStyle: {
              borderWidth: 3,
              color: function color(params) {
                if (_this5.colorData[params.dataIndex] == '合格') {
                  return 'green';
                } else {
                  return 'red';
                }
              }
            }
          }]
        };
        myChart.setOption(option);
      }
    },
    // 跨度图表
    drawSpanChart: function drawSpanChart() {
      var _this6 = this;

      var spanEcharts = require('echarts'); //先引入echarts


      var spanRoseCharts = document.getElementsByClassName('spanDataChart');

      for (var j = 0; j < this.PinformationChart.length; j++) {
        var mySpanChart = spanEcharts.init(spanRoseCharts[j]);
        this.yAxisSpanData = [];
        this.colorSpanData = [];
        this.spanData.forEach(function (item) {
          if (item.qcData[_this6.PinformationChart[j].code]) {
            _this6.yAxisSpanData.push(item.qcData[_this6.PinformationChart[j].code].spanDriftRelativeError.replace('%', '') - 0);

            _this6.colorSpanData.push(item.qcData[_this6.PinformationChart[j].code].spanDriftValid);

            _this6.spanErrorStandard = item.qcData[_this6.PinformationChart[j].code].errorStandard;
          } else {
            _this6.yAxisSpanData.push('');

            _this6.colorSpanData.push('');
          }
        });
        console.log('this.yAxisSpanData', this.yAxisSpanData);
        var spanOption = {
          title: {
            text: '24小时跨度漂移历史数据',
            subtext: this.PinformationChart[j].title,
            left: 'center'
          },
          toolbox: {
            show: true,
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              magicType: {
                show: true,
                type: ['line', 'bar']
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            textStyle: {
              // 文字提示样式
              color: '#fff',
              fontSize: '12'
            }
          },
          xAxis: {
            name: '时间',
            type: 'category',
            data: this.xAxisSpanData
          },
          yAxis: {
            name: '相对误差(%)',
            type: 'value'
          },
          series: [{
            name: this.PinformationChart[j].title,
            data: this.yAxisSpanData,
            type: 'line',
            symbol: 'triangle',
            symbolSize: 20,
            markLine: {
              data: [{
                yAxis: this.spanErrorStandard - 0,
                name: 'max'
              }, {
                yAxis: 0 - this.spanErrorStandard,
                name: 'min'
              }]
            },
            lineStyle: {
              color: 'green',
              width: 4,
              type: 'dashed'
            },
            itemStyle: {
              borderWidth: 3,
              color: function color(params) {
                if (_this6.colorSpanData[params.dataIndex] == '合格') {
                  return 'green';
                } else {
                  return 'red';
                }
              }
            }
          }]
        };
        mySpanChart.setOption(spanOption);
      }
    },
    // 零点图表数据请求
    getActionChart: function getActionChart() {
      var _this7 = this;

      // 请求数据
      var params = {
        siteId: this.queryParam.scopeId,
        stime: this.queryParam.stime,
        etime: this.queryParam.etime,
        factorStr: this.queryParam.factorStr,
        order: 'desc'
      }; // 零点数据

      getAction('/om/day/quality/zero', params).then(function (res) {
        if (res.success) {
          _this7.actionData = res.result;
          var temp = res.result[0].factorModels;
          _this7.PinformationChart = temp;
          _this7.xAxisData = [];
          res.result.forEach(function (item) {
            _this7.xAxisData.push(item.dateTime);
          });

          _this7.$nextTick(function () {
            _this7.drawActionChart();
          });
        }
      });
    },
    // 跨度图表数据请求
    getSpanChart: function getSpanChart() {
      var _this8 = this;

      // 请求数据
      var params = {
        siteId: this.queryParam.scopeId,
        stime: this.queryParam.stime,
        etime: this.queryParam.etime,
        factorStr: this.queryParam.factorStr,
        order: 'desc'
      }; // 跨度数据

      getAction('/om/day/quality/span', params).then(function (res) {
        if (res.success) {
          var temp = res.result[0].factorModels;
          _this8.PinformationChart = temp;
          _this8.spanData = res.result;
          _this8.xAxisSpanData = [];
          res.result.forEach(function (item) {
            _this8.xAxisSpanData.push(item.dateTime);
          });

          _this8.$nextTick(function () {
            _this8.drawSpanChart();
          });
        }
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};